import { Box, CircularProgress } from '@mui/material'
import { DueForReviewStrip } from '../components/games/DueForReviewStrip'
import { GamesLauncher } from '../components/games/GamesLauncher'
import { RecentActivityList } from '../components/games/RecentActivityList'
import { useAuth } from '../hooks/useAuth'
import { useDueVerses } from '../hooks/useDueVerses'
import { useRecentSessions } from '../hooks/useRecentSessions'

export default function LearnPractice() {
  const { user } = useAuth()
  const { sessions, loading: sessionsLoading } = useRecentSessions(25)
  const { verses: dueVerses } = useDueVerses()

  if (!user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box>
      <DueForReviewStrip verses={dueVerses} />
      <GamesLauncher sessions={sessions} />
      {!sessionsLoading && <RecentActivityList sessions={sessions.slice(0, 5)} />}
    </Box>
  )
}

